
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"23","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1010_2053)"}},[_c('path',{attrs:{"d":"M22.622 9.835L12.527.84a1.168 1.168 0 00-1.554 0L.878 9.835a1.104 1.104 0 00-.299 1.241c.173.438.596.72 1.076.72h1.612v9.012c0 .357.297.647.662.647h5.533c.366 0 .662-.29.662-.647h3.252c0 .358.296.647.662.647h5.533c.365 0 .661-.29.661-.647v-9.011h1.613c.48 0 .903-.283 1.076-.721a1.105 1.105 0 00-.299-1.241zM20.06 1.836h-4.443l5.105 4.539V2.483a.654.654 0 00-.662-.647z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1010_2053"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.5)","d":"M0 0h22.5v22H0z"}})])])])
          )
        }
      }
    